import { SoledadUtils } from './../../lib/helpers/utils';

export interface Expiration {
    nombreEmpresa: string;
    responsableCobro: number;
    responsableCobronombre: string;
    ejercicio: number;
    cliente: number;
    clienteNombre: string;
    factura: string;
    fechaEmisionDocumento: string;
    vencimiento: string;
    claveCartera: string;
    claveCarteraNombre: string;
    importe: number;
    impagado: string;
    vencimientoDate: Date;
    fechaEmisionDocumentoDate: Date;
    bloqueado: string;
    exclamacion: string;
    sumar: boolean;
}

export class ExpirationHelper {

    static create(): Expiration {
        return {
            nombreEmpresa: '',
            responsableCobro: 0,
            responsableCobronombre: '',
            ejercicio: 0,
            cliente: 0,
            clienteNombre: '',
            factura: '',
            fechaEmisionDocumento: '',
            vencimiento: '',
            claveCartera: '',
            claveCarteraNombre: '',
            importe: 0,
            impagado: '',
            vencimientoDate: null,
            fechaEmisionDocumentoDate: null,
            bloqueado: '',
            exclamacion: '',
            sumar: true,
        };
    }

    static transformFromApi(apiData: Object): Expiration {
        const obj = ExpirationHelper.create();
        obj.nombreEmpresa = apiData['VE_NOMBREEMPRESA'];
        obj.responsableCobro = apiData['VE_RESPONSABLECOBRO'];
        obj.responsableCobronombre = apiData['VE_RESPONSABLECOBRONOMBRE'];
        obj.ejercicio = apiData['VE_EJERCICIO'];
        obj.cliente = apiData['VE_CLIENTE'];
        obj.clienteNombre = apiData['VE_CLIENTENOMBRE'];
        obj.factura = apiData['VE_FACTURA'];
        obj.fechaEmisionDocumento = apiData['VE_FECHAEMISIONDOCUMENTO'];
        obj.vencimiento = apiData['VE_VENCIMIENTO'];
        obj.claveCartera = apiData['VE_CLAVECARTERA'];
        obj.claveCarteraNombre = apiData['VE_CLAVECARTERANOMBRE'];
        obj.importe = apiData['VE_IMPORTE'];
        obj.impagado = apiData['VE_IMPAGADO'];
        obj.vencimientoDate = SoledadUtils.dateTimeParse(apiData['VE_VENCIMIENTODATE']);
        obj.fechaEmisionDocumentoDate = SoledadUtils.dateTimeParse(apiData['VE_FECHAEMISIONDOCUMENTODATE']);
        obj.bloqueado = apiData['VE_BLOQUEADO'];
        obj.exclamacion = apiData['VE_EXCLAMACION'];
        
        if (typeof apiData['VE_SUMAR']  === 'undefined') {
            obj.sumar = true;
        } else {
            obj.sumar = apiData['VE_SUMAR'];
        }

        return obj;
    }
}
